export enum Status {
  InTransit = "In transit",
  ScheduledPU = "Scheduled PU",
  AtReceiver = "At receiver",
  Delivered = "Delivered",
  Loaded = "Loaded",
  SPu = "S Pu",
  AtShipper = "At Shipper",
  InTransitToPU = "In transit to PU",
}
